varying vec2 vUv; 
varying vec3 vNormal; 
varying vec3 vPos; 
varying vec3 vWorldPos; 
// 
uniform vec3 u_targetPos;
void main(){



    vec4 modelPosition = modelMatrix * instanceMatrix* vec4(position, 1.0);
//    float dist = u_targetPos.x - modelPosition.x;

// // Crée un offset en Y selon la distance (par exemple avec une courbe douce)
// float yOffset = smoothstep(0.0, 9.0, -dist) * 1.0 ; // monte de 0 à 1 sur 5 unités

// // Applique l'offset en Y à toute l'instance
// modelPosition.y -= yOffset;



    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // aditionnal calculations
    vUv = uv;
    vNormal = normal;
    vPos = position;
    vWorldPos = modelPosition.xyz;

}